import React, { useState ,useEffect} from 'react';
import './ContactForm.css';
import { motion } from 'framer-motion';
// import {useToast} from "@chakra-ui/toast";
import Swal from 'sweetalert2';
import { toast } from 'sonner';

import { useLocation,useNavigate } from 'react-router-dom';
const ContactForm = () => {
    const words = ['Price', 'Estimate'];
    const fadeInUp = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.2,
                duration: 0.5,
                ease: 'easeOut',
            },
        }),
    };
    const location = useLocation();
    const navigate = useNavigate();
    // const toast = useToast();

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile_number: '',
        date: '',
        time: '',
        message: '',
    });

    const [errors, setErrors] = useState({});
    // const [successMsg, setSuccessMsg] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email is invalid';
        }
        if (!formData.mobile_number.trim()) newErrors.mobile_number = 'Mobile number is required';
        if (!formData.date) newErrors.date = 'Date is required';
        if (!formData.time) newErrors.time = 'Time is required';
        if (!formData.message.trim()) newErrors.message = 'Message is required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const payload = {
            name: formData.name,
            email: formData.email,
            mobile_number: formData.mobile_number,
            date_time: `${formData.date} ${formData.time}`,
            message: formData.message,
        };

        try {
            const response = await fetch('https://admin.ezerautomotive.co.nz/api/contact-form/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                // setSuccessMsg('Your message has been sent successfully!');
                // toast({
                //     title: "Success Notification!",
                //     status: "success",
                //     duration: 5000,
                //     isClosable: true,
                //   });
                // Swal.fire({
                //     icon: 'success',
                //     title: 'Message Sent!',
                //     text: 'We will get back to you shortly.',
                //   });
                toast.success('Message sent successfully!');
                setFormData({
                    name: '',
                    email: '',
                    mobile_number: '',
                    date: '',
                    time: '',
                    message: '',
                });
                setErrors({});
            } else {
                const data = await response.json();
                alert('Submission failed: ' + JSON.stringify(data));
            }
        } catch (error) {
            // Swal.fire({
            //     icon: 'error',
            //     title: 'Oops...',
            //     text: 'Something went wrong!',
            //   });
            toast.error('Failed to send the message.');
            console.error('Error submitting form:', error);
            // alert('An error occurred. Please try again later.');
        }
    };

    return (
        <div id='contact' className="contact-container">
            <h2 className="form-title chakra-petch-bold">
                {words.map((word, i) => (
                    <motion.span
                        key={i}
                        custom={i}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={fadeInUp}
                        style={{ display: 'inline-block', marginRight: '0.5rem' }}
                    >
                        {word}
                    </motion.span>
                ))}
            </h2>
            <p className="form-subtitle font-mulish">
                After you submit the form, a representative will call you back with the information you'll need to make an appointment.
            </p>

            {/* {successMsg && <p className="success-msg">{successMsg}</p>} */}

            <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group">
                        <label className='chakra-petch-semibold'>Your Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className='font-mulish'
                            style={{ padding: '10px 0px' }}
                        />
                        {errors.name && <span className="error">{errors.name}</span>}
                    </div>

                    <div className="form-group">
                        <label className='chakra-petch-semibold'>Your Email</label>
                        <input
                            type="email"
                            name="email"
                            placeholder="Enter Your Email"
                            value={formData.email}
                            onChange={handleChange}
                            className='font-mulish'
                            style={{ padding: '10px 0px' }}
                        />
                        {errors.email && <span className="error">{errors.email}</span>}
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label className='chakra-petch-semibold'>Mobile Number</label>
                        <input
                            type="text"
                            name="mobile_number"
                            value={formData.mobile_number}
                            onChange={handleChange}
                            className='font-mulish'
                            style={{ padding: '10px 0px' }}
                        />
                        {errors.mobile_number && <span className="error">{errors.mobile_number}</span>}
                    </div>

                    <div className="form-group">
                        <label className='chakra-petch-semibold'>Select Date</label>
                        <input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleChange}
                            style={{ padding: '10px 0px' }}
                        />
                        {errors.date && <span className="error">{errors.date}</span>}
                    </div>

                    <div className="form-group">
                        <label className='chakra-petch-semibold'>Select Time</label>
                        <input
                            type="time"
                            name="time"
                            value={formData.time}
                            onChange={handleChange}
                            style={{ padding: '10px 0px' }}
                        />
                        {errors.time && <span className="error">{errors.time}</span>}
                    </div>
                </div>

                <div className="form-group full-width">
                    <label className='chakra-petch-semibold'>Your Message</label>
                    <textarea
                        name="message"
                        placeholder="Describe Your Problem"
                        rows="5"
                        value={formData.message}
                        onChange={handleChange}
                        className='font-mulish'
                        style={{ padding: '10px 0px' }}
                    ></textarea>
                    {errors.message && <span className="error">{errors.message}</span>}
                </div>

                <button type="submit" className="submit-btn chakra-petch-semibold">Send Message</button>
            </form>
        </div>
    );
};

export default ContactForm;
